// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.top-menu {
  width: 100%;
  background-color: #172228;
  display: flex;
  align-items: end;
  justify-content: flex-start;
  padding: 0 15px;
  height: 70px;
  z-index: 100;
}

.menu-toggle {
  background: none;
  border: none;
  color: #fff;
  font-size: 24px;
  display: none;
  cursor: pointer;
  text-align: left;
} 

.menu-container.open .top-menu {
  display: block; 
}

.menu-container {
  width: 100%;
  display: flex;
  flex-direction: column; 
  justify-content: flex-start;
  align-items: flex-start;
  position: relative;
  height: 70px;
}

.menu-list {
  display: flex;
  list-style: none;
  padding: 0;
  margin: 0;
  justify-content: flex-start;
  align-items: center;
}

.menu-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #ffffff; 
  padding: 10px 15px 5px 15px;
  cursor: pointer;
  transition: transform 0.5s ease, color 0.5s ease;
  font-size: 0.9em; 
  position: relative;
}

.menu-item svg {
  font-size: 28px;
  color: #ffffff; 
  transition: color 0.5s ease, transform 0.5s ease;
  margin-bottom: 5px; 
}

.menu-item span {
  font-size: 14px;
  font-weight: bold;
  color: #ffffff;
}

.menu-item:hover svg {
  color: #d8b8a1; 
}

.menu-item:hover span {
  color: #d8b8a1;
  transition: color 0.5s ease, transform 0.5s ease;
}

.menu-item.active svg,
.menu-item.active span {
  color: #d8b8a1;
}

.menu-item a {
  text-decoration: none;
}

.submenu {
  background-color: #172228;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  left: 0;
  display: none;
  z-index: 99;
}

.submenu.show {
  display: block; 
  width: 100%;
}

.submenu-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
}

.submenu-item {
  padding: 15px 20px 14px 20px;
}

.submenu-item.active span {
  color: #f0f0f0;
}

.submenu-item.active span::after {
  width: 100%; 
  transition: none; 
}

.submenu-list a {
  color: #f0f0f0;
  font-size: 14px;
  font-weight: bold;
  text-decoration: none;
}

.submenu-list a span {
  position: relative;
  display: inline-block;
}

.submenu-list a span::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 0;
  height: 2px;
  background-color: #d8b8a1;
  transition: width 0.5s ease;
}

.submenu-list a:hover span::after {
  width: 100%;
}

a {
  text-decoration: none;
}

.menu-expand-icon {
  display: none;
  margin-left: 6px;
  font-size: 12px;
}

.menu-container.mobile {
  transition: height 0.3s ease;
}

.menu-container.mobile.open {
  height: auto !important;
  overflow: visible;
}

.menu-container.mobile .menu-list {
  width: 100%;
}

.menu-item-content {
  display: flex;
  align-items: center;
}

.menu-wrapper {
  width: 100%;
}

.menu-wrapper .submenu {
  width: 100%;
}

.menu-item + .submenu.show {
  margin-top: 0;
  margin-bottom: 0;
}

.menu-wrapper a:last-child .submenu-item {
  border-bottom: none;
}

@media (max-width: 1128px) {
  .menu-list {
    display: none; 
    flex-direction: column;
  }

  .menu-container.open .top-menu .menu-toggle {
    display: block; 
    position: absolute;
    top: 20px;
    left: 15px;
    right: auto;
  }

  .menu-container.open .menu-list {
    display: flex; 
    margin-top: 50px;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    padding-top: 10px;
  }

  .menu-container.open .top-menu {
    height: auto;
    padding: 15px;
    padding-bottom: 0;
    position: relative;
  }

  .top-menu {
    flex-wrap: wrap;
    height: 70px;    
    align-items: center;
  }

  .menu-item {
    padding: 12px 15px;
    margin: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    border-bottom: none;
    position: relative;
    transition: background-color 0.2s ease;
  }

  .menu-item svg:not(.menu-expand-icon) {
    display: none;
  }

  .menu-item span {
    font-size: 16px;
    flex-grow: 1;
    text-align: left;
  }

  .menu-toggle {
    display: block; 
  }
  
  .menu-container.open .top-menu {
    height: auto;
    padding: 15px;
    padding-bottom: 0;
    position: relative;
  }

  .top-menu {
    flex-wrap: wrap;
    height: 70px;    
    align-items: center;
  }

  .submenu-list {
    display: flex;
    flex-direction: column;
  }

  .menu-wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
    position: relative;
    background-color: #172228;
    border-bottom: none;
  }

  .menu-wrapper .menu-item {
    border-bottom: none;
  }

  .menu-wrapper .submenu.show {
    border-bottom: none;
  }

  .menu-wrapper + .menu-wrapper,
  .menu-wrapper + a li,
  a + .menu-wrapper {
    border-top: none;
  }
  
  .menu-item:hover {
    background-color: #1d2a32;
  }

  .submenu.show {
    display: block;
    position: static;
    width: 100%;
    z-index: 99;
    box-shadow: none;
    background-color: transparent;
    margin-bottom: 0;
    margin-top: 0;
    overflow: hidden;
    border-bottom: none;
  }

  .submenu-list {
    padding: 0;
  }

  .submenu-item {
    padding: 12px 15px 12px 35px;
    margin: 0;
    border-bottom: none;
    background-color: #111a1f;
    transition: background-color 0.2s ease;
  }
  
  .submenu-item:hover {
    background-color: #192630;
  }
  
  .submenu-item:last-child {
    border-bottom: none;
  }
  
  .menu-item.active + .submenu.show {
    margin-top: 0;
  }
  
  .menu-item.active + .submenu.show + .menu-item {
    border-top: none;
  }

  .menu-expand-icon {
    display: inline-block;
    margin-left: 10px;
    margin-right: 0;
    font-size: 14px;
  }
  
  .menu-item-content {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-grow: 1;
  }

  .submenu-item.active span {
    color: #d8b8a1;
  }
  
  .submenu-item.active span::after {
    display: none;
  }
  
  .menu-item:hover span,
  .menu-item.active span {
    color: #d8b8a1;
  }
  
  .submenu-list a:hover span::after {
    display: none;
  }
  
  .submenu-list a:hover span {
    color: #d8b8a1;
  }
}

@media (min-width: 1129px) {
  .menu-item-content {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  
  .menu-item svg:not(.menu-expand-icon) {
    display: inline-block;
  }
  
  .submenu {
    border-bottom: none;
  }
  
  .menu-wrapper {
    width: auto;
    display: inline;
  }
  
  .menu-wrapper .submenu.show {
    position: absolute;
    top: 70px;
    left: 0;
    border-bottom: none;
  }
}

@media (max-width: 480px) {
  .menu-item {
    padding: 10px 15px;
  }
  
  .menu-item svg {
    font-size: 16px;
  }
  
  .menu-item span {
    font-size: 14px; 
  }
  
  .submenu-item {
    padding: 10px 15px 10px 35px;
  }
  
  .submenu-list a span {
    font-size: 13px;
  }
}

.container-fluid {
  padding: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/menu.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;EACf,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,2BAA2B;EAC3B,eAAe;EACf,gDAAgD;EAChD,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gDAAgD;EAChD,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gDAAgD;AAClD;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,0CAA0C;EAC1C,OAAO;EACP,aAAa;EACb,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;AACf;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,QAAQ;EACR,WAAW;EACX,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;EACb;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,sCAAsC;EACxC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;;IAGE,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,6BAA6B;IAC7B,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,4BAA4B;IAC5B,SAAS;IACT,mBAAmB;IACnB,yBAAyB;IACzB,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;IACrB,iBAAiB;IACjB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;AACf","sourcesContent":[".top-menu {\n  width: 100%;\n  background-color: #172228;\n  display: flex;\n  align-items: end;\n  justify-content: flex-start;\n  padding: 0 15px;\n  height: 70px;\n  z-index: 100;\n}\n\n.menu-toggle {\n  background: none;\n  border: none;\n  color: #fff;\n  font-size: 24px;\n  display: none;\n  cursor: pointer;\n  text-align: left;\n} \n\n.menu-container.open .top-menu {\n  display: block; \n}\n\n.menu-container {\n  width: 100%;\n  display: flex;\n  flex-direction: column; \n  justify-content: flex-start;\n  align-items: flex-start;\n  position: relative;\n  height: 70px;\n}\n\n.menu-list {\n  display: flex;\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.menu-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  color: #ffffff; \n  padding: 10px 15px 5px 15px;\n  cursor: pointer;\n  transition: transform 0.5s ease, color 0.5s ease;\n  font-size: 0.9em; \n  position: relative;\n}\n\n.menu-item svg {\n  font-size: 28px;\n  color: #ffffff; \n  transition: color 0.5s ease, transform 0.5s ease;\n  margin-bottom: 5px; \n}\n\n.menu-item span {\n  font-size: 14px;\n  font-weight: bold;\n  color: #ffffff;\n}\n\n.menu-item:hover svg {\n  color: #d8b8a1; \n}\n\n.menu-item:hover span {\n  color: #d8b8a1;\n  transition: color 0.5s ease, transform 0.5s ease;\n}\n\n.menu-item.active svg,\n.menu-item.active span {\n  color: #d8b8a1;\n}\n\n.menu-item a {\n  text-decoration: none;\n}\n\n.submenu {\n  background-color: #172228;\n  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);\n  left: 0;\n  display: none;\n  z-index: 99;\n}\n\n.submenu.show {\n  display: block; \n  width: 100%;\n}\n\n.submenu-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n}\n\n.submenu-item {\n  padding: 15px 20px 14px 20px;\n}\n\n.submenu-item.active span {\n  color: #f0f0f0;\n}\n\n.submenu-item.active span::after {\n  width: 100%; \n  transition: none; \n}\n\n.submenu-list a {\n  color: #f0f0f0;\n  font-size: 14px;\n  font-weight: bold;\n  text-decoration: none;\n}\n\n.submenu-list a span {\n  position: relative;\n  display: inline-block;\n}\n\n.submenu-list a span::after {\n  content: '';\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  width: 0;\n  height: 2px;\n  background-color: #d8b8a1;\n  transition: width 0.5s ease;\n}\n\n.submenu-list a:hover span::after {\n  width: 100%;\n}\n\na {\n  text-decoration: none;\n}\n\n.menu-expand-icon {\n  display: none;\n  margin-left: 6px;\n  font-size: 12px;\n}\n\n.menu-container.mobile {\n  transition: height 0.3s ease;\n}\n\n.menu-container.mobile.open {\n  height: auto !important;\n  overflow: visible;\n}\n\n.menu-container.mobile .menu-list {\n  width: 100%;\n}\n\n.menu-item-content {\n  display: flex;\n  align-items: center;\n}\n\n.menu-wrapper {\n  width: 100%;\n}\n\n.menu-wrapper .submenu {\n  width: 100%;\n}\n\n.menu-item + .submenu.show {\n  margin-top: 0;\n  margin-bottom: 0;\n}\n\n.menu-wrapper a:last-child .submenu-item {\n  border-bottom: none;\n}\n\n@media (max-width: 1128px) {\n  .menu-list {\n    display: none; \n    flex-direction: column;\n  }\n\n  .menu-container.open .top-menu .menu-toggle {\n    display: block; \n    position: absolute;\n    top: 20px;\n    left: 15px;\n    right: auto;\n  }\n\n  .menu-container.open .menu-list {\n    display: flex; \n    margin-top: 50px;\n    flex-direction: column;\n    align-items: flex-start;\n    width: 100%;\n    padding-top: 10px;\n  }\n\n  .menu-container.open .top-menu {\n    height: auto;\n    padding: 15px;\n    padding-bottom: 0;\n    position: relative;\n  }\n\n  .top-menu {\n    flex-wrap: wrap;\n    height: 70px;    \n    align-items: center;\n  }\n\n  .menu-item {\n    padding: 12px 15px;\n    margin: 0;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    border-bottom: none;\n    position: relative;\n    transition: background-color 0.2s ease;\n  }\n\n  .menu-item svg:not(.menu-expand-icon) {\n    display: none;\n  }\n\n  .menu-item span {\n    font-size: 16px;\n    flex-grow: 1;\n    text-align: left;\n  }\n\n  .menu-toggle {\n    display: block; \n  }\n  \n  .menu-container.open .top-menu {\n    height: auto;\n    padding: 15px;\n    padding-bottom: 0;\n    position: relative;\n  }\n\n  .top-menu {\n    flex-wrap: wrap;\n    height: 70px;    \n    align-items: center;\n  }\n\n  .submenu-list {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .menu-wrapper {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    position: relative;\n    background-color: #172228;\n    border-bottom: none;\n  }\n\n  .menu-wrapper .menu-item {\n    border-bottom: none;\n  }\n\n  .menu-wrapper .submenu.show {\n    border-bottom: none;\n  }\n\n  .menu-wrapper + .menu-wrapper,\n  .menu-wrapper + a li,\n  a + .menu-wrapper {\n    border-top: none;\n  }\n  \n  .menu-item:hover {\n    background-color: #1d2a32;\n  }\n\n  .submenu.show {\n    display: block;\n    position: static;\n    width: 100%;\n    z-index: 99;\n    box-shadow: none;\n    background-color: transparent;\n    margin-bottom: 0;\n    margin-top: 0;\n    overflow: hidden;\n    border-bottom: none;\n  }\n\n  .submenu-list {\n    padding: 0;\n  }\n\n  .submenu-item {\n    padding: 12px 15px 12px 35px;\n    margin: 0;\n    border-bottom: none;\n    background-color: #111a1f;\n    transition: background-color 0.2s ease;\n  }\n  \n  .submenu-item:hover {\n    background-color: #192630;\n  }\n  \n  .submenu-item:last-child {\n    border-bottom: none;\n  }\n  \n  .menu-item.active + .submenu.show {\n    margin-top: 0;\n  }\n  \n  .menu-item.active + .submenu.show + .menu-item {\n    border-top: none;\n  }\n\n  .menu-expand-icon {\n    display: inline-block;\n    margin-left: 10px;\n    margin-right: 0;\n    font-size: 14px;\n  }\n  \n  .menu-item-content {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    flex-grow: 1;\n  }\n\n  .submenu-item.active span {\n    color: #d8b8a1;\n  }\n  \n  .submenu-item.active span::after {\n    display: none;\n  }\n  \n  .menu-item:hover span,\n  .menu-item.active span {\n    color: #d8b8a1;\n  }\n  \n  .submenu-list a:hover span::after {\n    display: none;\n  }\n  \n  .submenu-list a:hover span {\n    color: #d8b8a1;\n  }\n}\n\n@media (min-width: 1129px) {\n  .menu-item-content {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n  \n  .menu-item svg:not(.menu-expand-icon) {\n    display: inline-block;\n  }\n  \n  .submenu {\n    border-bottom: none;\n  }\n  \n  .menu-wrapper {\n    width: auto;\n    display: inline;\n  }\n  \n  .menu-wrapper .submenu.show {\n    position: absolute;\n    top: 70px;\n    left: 0;\n    border-bottom: none;\n  }\n}\n\n@media (max-width: 480px) {\n  .menu-item {\n    padding: 10px 15px;\n  }\n  \n  .menu-item svg {\n    font-size: 16px;\n  }\n  \n  .menu-item span {\n    font-size: 14px; \n  }\n  \n  .submenu-item {\n    padding: 10px 15px 10px 35px;\n  }\n  \n  .submenu-list a span {\n    font-size: 13px;\n  }\n}\n\n.container-fluid {\n  padding: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
